<template>
  <b-modal
    v-model="isOpenAuthenticationModal"
    id="xendit-card-authentication"
    title="Card Authentication"
    @hidden="resetAuthenticationModal"
    dialog-class="modal-full-dialog"
    content-class="modal-full-content"
    centered
    hide-footer
  >
    <template v-if="authenticationUrl">
      <iframe
        :src="authenticationUrl"
        class="h-100 w-100 border-0"
        title="Authentication"
      ></iframe>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: ['isOpenAuthenticationModal', 'authenticationUrl'],
  methods: {
    resetAuthenticationModal() {
      this.$root.$emit('setAuthenticationConfigs', {
        authenticationUrl: null,
        isOpenAuthenticationModal: false
      });
    }
  }
}
</script>
